import { Injectable, Inject, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, forkJoin, of, Observable } from 'rxjs';
import { exhaustMap, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { TableService, TableResponseModel, ITableState , BaseModel, PaginatorState, SortState, GroupingState } from '../../_metronic/shared/crud-table';
import { Policy } from '../_models/policy.model';
import { Claim } from '../_models/claim.model';
import { QuoteLife, Quote, QuoteDocuments } from '../_models/quote.model';;
import { baseFilter } from '../../_fake/fake-helpers/http-extenstions';
import { catchError, finalize, tap } from 'rxjs/operators';
import { first } from 'rxjs/operators';
import { AuthService } from '../../modules/auth/_services/auth.service';

const DEFAULT_STATE: ITableState = {
	filter: {},
	paginator: new PaginatorState(),
	sorting: new SortState(),
	searchTerm: '',
	grouping: new GroupingState(),
	entityId: undefined,
	paramsGet: "",
	paramsPost: {}
  };
  
  @Injectable({
	providedIn: 'root'
  })

export class ClaimsService extends TableService<Policy> implements OnDestroy {

	apiUrls = {
		getPolicy : `${environment.url}/${environment.apiUrl}/Producer/get_Listados_De_Polizas?`,
        getClaims : `${environment.url}/${environment.apiUrl}/Reclamos/get_reclamos?`,
		postCrearReclamo : `${environment.url}/${environment.apiUrl}/Reclamos/post_crear_reclamo?`,
		getDocumentosReclamo : `${environment.url}/${environment.apiUrl}/Reclamos/get_documentos_reclamo?`,
        getDescargarDocumentosReclamo : `${environment.url}/${environment.apiUrl}/Reclamos/get_descargar_documentos_reclamo?`,
        postCargarDocumentoReclamo: `${environment.url}/${environment.apiUrl}/Reclamos/post_cargar_documento_reclamo?`,
        getTipoInteres : `${environment.url}/${environment.apiUrl}/Generico/get_tipo_interes?`,
        getCausaReclamo  : `${environment.url}/${environment.apiUrl}/Generico/get_causa_reclamo?`,
	}

	constructor(@Inject(HttpClient) http, private auth: AuthService) {
		super(http);
	}

	// READ
	find(tableState: ITableState): Observable<TableResponseModel<Policy>> {
		return this.http.get<Policy[]>(this.apiUrls.getPolicy + tableState.paramsGet, {headers: this.auth.httpHeaders}).pipe(
		  map((response: Policy[]) => {
			const filteredResult = baseFilter(response, tableState);
			const result: TableResponseModel<Policy> = {
			  items: response, // filteredResult.items,
			  total: filteredResult.total
			};
			return result;
		  })
	)}

	async postCrearReclamo(params: any) {
		var data = new FormData();
		data.append("data", JSON.stringify([params]));
		
		return await this.http.post<Claim>(this.apiUrls.postCrearReclamo, data, {headers: this.auth.httpHeaders}).toPromise();
	}

    async postCargarDocumentoReclamo(params: any, doc: any = null) {
        var data = new FormData();
        data.append("IdReclamo", params.IdReclamo);
        data.append("IdTipoDocumento", params.IdTipoDocumento);
        data.append(params.file, (document.getElementById(params.file) as HTMLInputElement).files[0])
        return await this.http.post<any>(this.apiUrls.postCargarDocumentoReclamo, data, {headers: this.auth.httpHeaders}).toPromise();
    }

    /*
    async getDescargarDocumentosReclamo(params: string='') {
        this.auth.httpHeaders.append('Content-Type', 'text/plain; charset=utf-8');
        return await this.http.get(this.apiUrls.getDescargarDocumentosReclamo + params, {headers: this.auth.httpHeaders, responseType : 'blob' }).toPromise();
    }
    */

    async getDescargarDocumentosReclamo(params: string) {
        var response = await this.http.get<Document>(this.apiUrls.getDescargarDocumentosReclamo + params, {headers: this.auth.httpHeaders}).toPromise();
        if(typeof response != 'undefined') {
          return response;
        }
      }

    async getTipoInteres(params: string='') {
        return await this.http.get(this.apiUrls.getTipoInteres + params, {headers: this.auth.httpHeaders}).toPromise();
    }

    async getCausaReclamo(params: string='') {
        return await this.http.get(this.apiUrls.getCausaReclamo + params, {headers: this.auth.httpHeaders}).toPromise();
    }

    async getDocumentosReclamo(params: string='') {
        return await this.http.get(this.apiUrls.getDocumentosReclamo + params, {headers: this.auth.httpHeaders}).toPromise();
    }

	extracData(id, policies) {
		var item;
	
		//FEXME
		policies.pipe().subscribe(items => {
		  return items.filter(c => {
			if(c.IdPoliza == id) {
			  return (item = c);
			}
		  });
		});
			
		return item;
	}
	
	ngOnDestroy() {
		this.subscriptions.forEach(sb => sb.unsubscribe());
	}
}
